import { useDOMPurify } from '../../../lib/useDOMPurify';
import { SimpleReactComponentProps } from '../../../types/components';
import { TitleBlockStyle } from '../../../types/optimizely/unions';
import { RichText } from '../atoms/RichText';
import { Title } from '../atoms/Title';

export interface TitleBlockProps extends SimpleReactComponentProps {
	title: string;
	type: TitleBlockStyle;
	subtitle: string;
}

const titleBlockClassName = 'flex flex-col scroll-mt-[84px]';
const textClassName = 'text-base text-primary pt-4';

export const TitleBlock = ({
	title,
	type,
	subtitle,
	anchorId,
}: TitleBlockProps) => {
	const sanitizedText = useDOMPurify(subtitle);

	return (
		<div className={titleBlockClassName} id={anchorId?.value}>
			<Title title={title} style={type} />
			<RichText richText={sanitizedText} className={textClassName} />
		</div>
	);
};
